import * as React from "react";
import type { SVGProps } from "react";
const SvgTag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="currentColor" d="M8 10.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.48 21.77a3 3 0 0 0 1.16.23 3 3 0 0 0 2.14-.89l4.83-4.83a3 3 0 0 0 0-4.28L12.5 3.88A3 3 0 0 0 10.36 3H6.5a4 4 0 0 0-4 4v3.86A3 3 0 0 0 3.39 13l8.11 8.11c.28.283.613.507.98.66ZM5.087 5.586A2 2 0 0 1 6.5 5h3.86a1 1 0 0 1 .72.3l8.12 8.12a1 1 0 0 1 0 1.45l-4.83 4.83a1 1 0 0 1-1.45 0L4.8 11.58a1 1 0 0 1-.3-.72V7a2 2 0 0 1 .586-1.414Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTag;
